import { Box } from '@material-ui/core';

import {
  EditAutoPaymentMethodSummaryRowData,
  EditAutoPaymentMethodSummarySection,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/components/EditAutoPaymentMethodSummarySection';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface EditAutoPaymentMethodSpecsChangesReviewProps {
  rows: EditAutoPaymentMethodSummaryRowData[];
}

export const EditAutoPaymentMethodSpecsChangesReview = ({ rows }: EditAutoPaymentMethodSpecsChangesReviewProps) => {
  if (rows.length === 0) {
    return null;
  }

  return (
    <Box width="100%" display="flex" flexDirection="column" gridGap={8}>
      <Font variant="subtitle1" color="title" style={{ fontWeight: 600 }}>
        <Text tId="NEW_VEHICLE_DETAILS" />
      </Font>
      <CustomPaper fill="paper" style={{ minWidth: 0 }}>
        <EditAutoPaymentMethodSummarySection rows={rows} />
      </CustomPaper>
    </Box>
  );
};
